module.exports = __webpack_public_path__ + "img/md.44f9c266.png";